<!--  -->
<template>
  <div class="tree">
    <div class="title">
      <div class="text">栏目管理</div>
      <div class="form">
        <a-form-model
          layout="inline"
          :model="formInline"
          @submit="serach"
          @submit.native.prevent
        >
          <a-form-model-item>
            <a-input
              placeholder="请输入栏目名称或者id"
              v-model="formInline.content"
            />
          </a-form-model-item>
          <a-form-model-item>
            <a-button html-type="submit" type="primary">查询</a-button>
          </a-form-model-item>
          <a-form-model-item v-if="info.role_id <= 2">
            <span class="operator" @click="$emit('add')">
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>新增栏目</span>
                </template>
                <a-button type="danger"> <a-icon type="plus" />添加 </a-button>
              </a-tooltip>
            </span>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
    <a-table
      :columns="columns"
      :dataSource="dataKey"
      :pagination="pagination"
      :rowKey="record => record.catid"
      :loading="tableLoding"
      :expandedRowKeys="expandedRowKeys"
      size="small"
      @expand="expand"
      @change="handleTableChange"
    >
      <template slot="catname" slot-scope="text, record">
        <span
          @click="linkUrl(record.linkurl, record.catid)"
          style="cursor:pointer"
          >{{ text }}</span
        >
      </template>
      <template
        slot="update_count"
        slot-scope="text, record"
        v-if="!record.children"
      >
        <span>{{ text }}</span>
      </template>
      <template slot="operation" slot-scope="text, record, index">
        <a @click="merge(record, index)" class="active" v-if="info.role_id <= 2"
          >合并</a
        >
        <a @click="edit(record, index)" class="active" v-if="info.role_id <= 2"
          >编辑</a
        >
        <a-popconfirm
          :title="delText"
          okText="确定"
          cancelText="取消"
          @confirm="delCate(record, index)"
        >
          <a class="active" v-if="info.role_id <= 2">删除</a>
        </a-popconfirm>

        <a-popconfirm
          title="确认要对栏目进行排序么？"
          ok-text="确定"
          cancel-text="取消"
          @confirm="sort('up', record, index)"
        >
          <a-icon type="up-circle" class="margin-l-5 soft" />
        </a-popconfirm>
        <a-popconfirm
          title="确认要对栏目进行排序么？"
          ok-text="确定"
          cancel-text="取消"
          @confirm="sort('down', record, index)"
        >
          <a-icon type="down-circle" class="margin-l-5 soft" />
        </a-popconfirm>
      </template>
      <template slot="footer" slot-scope="currentPageData">
        <b>文章合计：</b>
        <b>{{ total(currentPageData) }}</b>
      </template>
    </a-table>
  </div>
</template>

<script>
const columns = [
  {
    title: '栏目名称',
    dataIndex: 'catname',
    scopedSlots: { customRender: 'catname' }
  },
  {
    title: '栏目id',
    dataIndex: 'catid',
    width: 150, //测试
    scopedSlots: { customRender: 'catid' }
  },

  {
    title: '文章数量',
    dataIndex: 'update_count',
    width: 200,
    scopedSlots: { customRender: 'update_count' },
    align: 'center'
  },

  {
    title: '操作',
    dataIndex: 'operation',
    width: 400,
    scopedSlots: { customRender: 'operation' },
    align: 'center'
  }
];
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      columns,
      formInline: { content: '' },
      pagination: {
        pageSize: 40,
        current: 1
      },
      setSiteInfo: {},
      siteLists: {},
      delText: '确认删除',
      expandedRowKeys: [],
      dataKey: [],
      dataAll: [],
      showType: this.type,
      info: JSON.parse(localStorage.getItem('siteinfo'))
    };
  },
  props: ['treeData', 'tableLoding', 'dataList', 'type'],
  computed: {},
  watch: {
    treeData: {
      immediate: true, // 很重要！！！
      handler(val) {
        this.dataKey = !val ? [] : val;
      }
    }
  },
  //方法集合
  created() {
    this.init();
    this.$message.config({
      top: '400px'
    });
    this.dataAll = this.dataList;
  },
  methods: {
    init() {
      this.setSiteInfo = JSON.parse(localStorage.getItem('siteinfo'));
      this.siteLists = JSON.parse(localStorage.getItem('siteLists'));
    },
    delCate(item, index) {
      let that = this;
      if (item.children) {
        return that.$message.error('请删除子栏目后，再删除父级栏目');
      } else {
        that.$http
          .post('/api/content/categorydel', { ids: item.catid })
          .then(res => {
            if (res.data.state == 200) {
              that.$message.success('操作成功');
              this.$emit('getCateList');
            } else {
              that.$message.error('操作失败，请刷新页面重试');
            }
          });
      }
    },
    edit(item, index) {
      this.$emit('editColumn', { item, index });
    },
    sort(type, record, index) {
      if (this.formInline.content != '' && record.parentid === '0') {
        this.$message.error('查询状态下无法对顶级栏目排序');
        return false;
      }
      this.$emit('dataSort', {
        type,
        record,
        index,
        pagination: this.pagination
      });
    },
    merge(item, index) {
      this.$emit('dataMerge', { item, index });
    },
    total(currentPageData) {
      let j = this.deepCopy(currentPageData);
      let data = this.deep(j);
      let total = 0;
      data.forEach(item => {
        if (item.children.length == 0) {
          total += parseInt(item.update_count);
        }
      });
      return total;
    },
    deep(node) {
      let stack = node,
        data = [];
      while (stack.length != 0) {
        let pop = stack.pop();
        data.push({
          id: pop.catid,
          name: pop.catname,
          parentId: pop.parentid,
          update_count: pop.update_count,
          children: pop.children ? pop.children : []
        });
        let children = pop.children;
        if (children) {
          for (let i = children.length - 1; i >= 0; i--) {
            stack.push(children[i]);
          }
        }
      }
      return data;
    },
    deepCopy(obj) {
      let clonedObj;
      let that = this;
      // 判断直接数据类型
      if (
        ['number', 'string', 'boolean', 'undefined', 'symbol'].includes(
          typeof obj
        ) ||
        obj === null
      ) {
        clonedObj = obj;
        return clonedObj;
      }
      const constructor = obj.constructor || Object;
      clonedObj = new constructor();
      Object.entries(obj).forEach(([key, value]) => {
        clonedObj[key] = that.deepCopy(value);
      });
      return clonedObj;
    },
    //跳转外链
    linkUrl(url, catid) {
      if (url) {
        window.open(url);
      } else {
        let siteId = this.setSiteInfo.site_id;
        let domain = '';
        this.siteLists.forEach(item => {
          if (item.siteid == siteId) {
            domain = item.domain;
          }
        });
        let Url = domain + 'content/lists?catid=' + catid;
        window.open(Url);
      }
    },
    expand(expanded, record) {
      if (expanded) {
        this.expandedRowKeys.push(record.catid);
      } else {
        let curr = this.expandedRowKeys.findIndex((current, index) => {
          return current === record.catid;
        });
        this.expandedRowKeys.splice(curr, 1);
      }
    },
    //查询
    serach(e) {
      let key = this.formInline.content;
      if (key == '' || key == undefined) {
        this.dataKey = this.treeData;
        return false;
      }
      if (key.length < 2) {
        this.$message.error('查询内容过短');
        return false;
      }
      this.dataKey = [];
      this.expandedRowKeys = [];
      this.treeData.findIndex((current, index) => {
        let item = JSON.stringify(current);
        if (item.indexOf(key) != -1) {
          this.dataKey.push(current);
        }
      });
      if (this.dataKey.length <= 0) {
        this.dataKey = [];
        return false;
      }
      let levelList = this.sonsTree(this.dataAll, this.dataKey[0].catid);
      this.expandedRowKeys.push(this.dataKey[0].catid);
      levelList.forEach(item => {
        if (item.children) {
          this.expandedRowKeys.push(item.catid);
        }
      });
    },
    sonsTree(arr, catid) {
      var temp = [];
      var forFn = function(arr, catid) {
        for (var i = 0; i < arr.length; i++) {
          var item = arr[i];
          if (item.parentid == catid) {
            temp.push(item);
            forFn(arr, item.catid);
          }
        }
      };
      forFn(arr, catid);
      return temp;
    },
    familyTree(arr, parentid) {
      var temp = [];
      var forFn = function(arr, parentid) {
        for (var i = 0; i < arr.length; i++) {
          var item = arr[i];
          if (item.catid == parentid) {
            temp.push(item.catid);
            forFn(arr, item.parentid);
          }
        }
      };
      forFn(arr, parentid);
      return temp;
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
    }
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
};
</script>
<style scoped>
.tree >>> .ant-table-row-expand-icon {
  border-color: #999;
}

.margin-l-5 {
  margin-left: 5px;
}
.soft {
  font-size: 16px;
  cursor: pointer;
}
.active {
  margin-right: 5px;
  color: #40a9ff;
}

.icon {
  margin-right: 5px;
  cursor: pointer;
}
.icon:hover {
  color: #1890ff;
}
.title {
  position: relative;
  height: 60px;
  line-height: 60px;
}
.text {
  position: absolute;
  left: 10px;
  font-size: 18px;
}
.form {
  position: absolute;
  padding-top: 10px;
  right: 0;
}
</style>
